<ui-breadcrumb-nav ariaLabel="Breadcrumb">
  <ui-breadcrumb>
    <a [routerLink]="['/organizations', organizationId()]">
      <ng-icon name="heroHome" size="20" class="!block" />
      <span class="sr-only"> {{ 'cockpit.nav.dashboard' | transloco }} </span>
    </a>
  </ui-breadcrumb>
  <ui-breadcrumb>
    <a [routerLink]="['/organizations', organizationId(), 'energy-interfaces']">
      {{ 'cockpit.nav.connections' | transloco }}
    </a>
  </ui-breadcrumb>
  <ui-breadcrumb>
    <a
      [routerLink]="['/organizations', organizationId(), 'energy-interfaces', energyInterfaceId()]"
      aria-current="page"
    >
      {{ 'cockpit.energyInterfaces.details.pageTitle' | transloco }}
    </a>
  </ui-breadcrumb>
</ui-breadcrumb-nav>
